import React, { Component } from "react";
import axiosInstance from "../../api/utils/axiosInstance";
import { connect } from "react-redux";
import {
  formSubmitError,
  formSubmitSuccess,
} from "../../store/actions/forms/formActions";
import {
  handleUserInput,
  handleMappedUserInput,
} from "../../helperFunctions/EntryFormHelperFunctions/userInputHandlers";
import {
  handleCountryAutocomplete,
  countryAutocompleteHandler,
  countyAutocompleteHandler,
  cityAndMuncipalityAutocomplete,
  districtAutocompleteHandler,
} from "../../helperFunctions/EntryFormHelperFunctions/autocompleteHelpers";
import { handleDayPicker } from "../../helperFunctions/EntryFormHelperFunctions/datePickerHelper";
import {
  validateRequiredFields,
  validateArrayFields,
} from "../../helperFunctions/validationHelpers/validateRequiredFields";
import EntryForm5 from "../../components/EntryForms/EntryForm5/EntryForm5";
import Spinner from "../../components/UI/Spinner/Spinner";
import fetchFormsApi from "../../api/formsApi/fetchFormsApi";
import { purgeUpdateAndRedirect } from "../../helperFunctions/purgeUpdateAndRedirect";
import { PURGE_UPDATE } from "../../constants/constants";

class RegistarRevDrustavIzDrugeDrzave extends Component {
  state = {
    countryList: [],
    countyList: [],
    showUpdateModal: false,
    cityAndMuncipalityList: [],
    districtList: [],
    networksList: [],
    legalForms: [],
    update: false,
    error: false,
    loader: false,
    requestsLoaded: false,
    networkMemberInfo: {
      isDrustvoMreza: false,
      idMreze: "",
    },
    newFormData: {
      oznDokumenta: {
        oznDokumenta: "",
      },
      userData: {
        vrDrustva: "3",
        idBroj: "",
        oznAkt: "",
        nazDrustva: "",
        regBroj: "",
        sifPOblika: "",
        brRegOrig: "",
        datReg: "",
        opisPOblika: "",

        requiredFieldsUserData: [
          "idBroj",
          "datReg",
          "nazDrustva",
          // "regBroj",
          "sifPOblika",
          "brRegOrig",
        ],
        tstampUnosa: null,
      },
      registrationAddress: {
        vrRegistracije: "1",
        sifDrzave: "",
        nazNaselja: "",
        brPoste: "",
        nazTijela: "",
        ulicaKbr: "",
        brReg: "",
        datReg: "",
        requiredFieldsRegistrationAddress: [
          "sifDrzave",
          "brReg",
          "datReg",
          "nazTijela",
        ],
      },
      hqAddress: {
        vrAdr: "1",
        sifDrzave: "",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        requiredFieldsHqAddress: ["sifDrzave"],
      },
      croAddress: {
        vrAdr: "1",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        requiredFieldsCroAddress: ["ulicaKbr"],
      },
      contactInformation: [
        {
          ime: "",
          prezime: "",
          telefon: "",
          web: "",
          email: "",
          emailValidated: "",
          id: 1,
        },
      ],
      officeAddress: [
        {
          vrAdr: "2",
          ulicaKbr: "",
          nazNaselja: "",
          brPoste: "",
          sifDrzave: "191",
          id: 1,
          requiredFieldsOfficeAddress: ["ulicaKbr", "nazNaselja", "brPoste"],
        },
      ],

      basicReviserData: [
        {
          oib: "",
          prezime: "",
          ime: "",
          regBroj: "",
          id: 1,
          idOsobe: "",
          requiredFieldsRevData: ["oib", "prezime", "ime", "regBroj"],
          oibValidated: false,
        },
      ],
      reviserRegistration: [
        {
          oib: "",
          prezime: "",
          ime: "",
          regBroj: "",
          id: 1,
          idOsobe: "",
          requiredFieldsReviserRegistration: [
            "oib",
            "prezime",
            "ime",
            "regBroj",
          ],
          oibValidated: false,
          // vrVeze: "1",
          // idDrustva: "",
          // oibIdBrojDrustva: "",
          // id: 1,
          // ime: "",
          // prezime: "",
          // nazDrustva: "",
          // dataFetched: false,
          // sifDrzave: "",
          // nazNaselja: "",
          // brPoste: "",
          // ulicaKbr: "",
          // web: "",
          // requiredFieldsReviserRegistration: ["vrVeze"],
        },
      ],
      auditCompanyMember: [
        {
          vrClana: "1",
          oib: "",
          ime: "",
          prezime: "",
          sifDrzave: "191",
          nazNaselja: "",
          naziv: "",
          brPoste: "",
          ulicaKbr: "",
          id: 1,
          oibValidated: false,
          requiredFieldsAuditCompanyMember: [
            // "ime",
            // "prezime",
            "sifDrzave",
            // "naziv",
            "ulicaKbr",
          ],
        },
      ],
      auditCompanyBoardMember: [
        {
          vrClana: "2",
          oib: "",
          ime: "",
          prezime: "",
          funkcija: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: 1,
          oibValidated: false,
          requiredFieldsAuditCompanyBoardMember: [
            "ime",
            "funkcija",
            "prezime",
            "sifDrzave",
            "ulicaKbr",
          ],
        },
      ],
      auditCompanyRegistration: [
        {
          vrRegistracije: "2",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
          id: 1,
        },
      ],
      auditCompanyRegistrationForeign: [
        {
          vrRegistracije: "3",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
          id: 1,
        },
      ],

      supervisoryAuthority: [
        {
          vrRegistracije: "4",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: 1,
        },
      ],
      createNewNetworkModal: false,
      createNewNetworkData: {
        nazMreze: "",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        requiredFieldsCreateNewNetwork: [
          "nazMreze",
          "sifDrzave",
          "nazNaselja",
          "brPoste",
          "ulicaKbr",
        ],
      },
      networkUpdateObj: {
        nazMreze: "",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        requiredFieldsNetworkUpdate: [
          "nazMreze",
          "nazNaselja",
          "brPoste",
          "ulicaKbr",
        ],
      },
      memberInfo: [
        {
          vrClana: "",
          memberType: "",
          id: 1,
          idDrugaDrzava: "",
          idMreze: "",
          idDrustva: "",
          nazDrustva: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          web: "",
          // oib: "",
          // oibValidated: false,
          // requiredFieldsMemberInfo: ["vrClana"]
        },
      ],
      dropDownData: [
        { id: 3, value: "Direktor"},
        { id: 4, value: "Predsjednik uprave" },
        { id: 5, value: "Član uprave" },
        { id: 6, value: "Prokurist" },
        { id: 7, value: "Član upravnog odbora" },
      ],
      mjere: [],
    },
  };

  componentDidMount = () => {
    this.getCountryList();
  };

  getDrustvoEdit = async (oznaka) => {
    const { idDrustva, vrDrustva } = this.props;

    const { data } = await axiosInstance.get(
      `/findDrustvo?idDrustva=${idDrustva}&vrDrustva=${vrDrustva}&showHistory=false`
    );

    const userInfo = data[1];

    const hqAddress = {
      vrAdr: "1",
      sifDrzave: String(data[2][0].sifDrzave),
      nazNaselja: data[2][0]?.nazNaselja || "",
      brPoste: data[2][0]?.brPoste || "",
      ulicaKbr: data[2][0]?.ulicaKbr || "",
      requiredFieldsHqAddress: ["sifDrzave"],
    };

    const croAddress = {
      vrAdr: "1",
      sifDrzave: String(data[2][1].sifDrzave),
      nazNaselja: data[2][1]?.nazNaselja || "",
      brPoste: data[2][1]?.brPoste || "",
      ulicaKbr: data[2][1]?.ulicaKbr || "",
      requiredFieldsCroAddress: ["ulicaKbr"],
    };

    const officeAddress = data[2]
      .filter((element) => element.vrAdr === 2)
      .map((element, index) => {
        return {
          vrAdr: "2",
          ulicaKbr: element?.ulicaKbr || "",
          nazNaselja: element?.nazNaselja || "",
          brPoste: element?.brPoste,
          sifDrzave: String(element.sifDrzave),
          id: index + 1,
          requiredFieldsOfficeAddress: ["ulicaKbr", "nazNaselja", "brPoste"],
        };
      });

    const regAdr = data[3][0];

    const registrationAddress = {
      vrRegistracije: "1",
      sifDrzave: String(data[3][1].sifDrzave),
      nazNaselja: data[3][1]?.nazNaselja || "",
      brPoste: data[3][1]?.brPoste || "",
      nazTijela: data[3][1]?.nazTijela || "",
      ulicaKbr: data[3][1]?.ulicaKbr,
      brReg: data[3][1]?.brReg || "",
      datReg: data[3][1]?.datReg || "",
      requiredFieldsRegistrationAddress: [
        "sifDrzave",
        "brReg",
        "datReg",
        "nazTijela",
      ],
    };

    const findAuditCompanyRegistration = data[3].filter(
      (element) => element.vrRegistracije === 2
    );

    let auditCompanyRegistration;
    if (findAuditCompanyRegistration.length > 0) {
      auditCompanyRegistration = findAuditCompanyRegistration.map(
        (element, index) => {
          return {
            vrRegistracije: "2",
            nazTijela: element?.nazTijela || "",
            sifDrzave: String(element?.sifDrzave || ""),
            nazNaselja: element?.nazNaselja || "",
            brPoste: element?.brPoste || "",
            ulicaKbr: element?.ulicaKbr || "",
            brReg: element?.brReg || "",
            datReg: element?.datReg || "",
            id: index + 1,
          };
        }
      );
    } else {
      auditCompanyRegistration =
        this.state.newFormData.auditCompanyRegistration;
    }

    const findAuditCompanyRegistrationForeign = data[3].filter(
      (element) => element.vrRegistracije === 3
    );

    let auditCompanyRegistrationForeign;
    if (findAuditCompanyRegistrationForeign.length > 0) {
      auditCompanyRegistrationForeign = findAuditCompanyRegistrationForeign.map(
        (element, index) => {
          return {
            vrRegistracije: "3",
            nazTijela: element?.nazTijela || "",
            sifDrzave: String(element?.sifDrzave || ""),
            nazNaselja: element?.nazNaselja || "",
            brPoste: element?.brPoste || "",
            ulicaKbr: element?.ulicaKbr || "",
            brReg: element?.brReg || "",
            datReg: element?.datReg || "",
            id: index + 1,
          };
        }
      );
    } else {
      auditCompanyRegistrationForeign =
        this.state.newFormData.auditCompanyRegistrationForeign;
    }

    const findSupervisoryAuthority = data[3].filter(
      (element) => element.vrRegistracije === 4
    );

    let supervisoryAuthority;
    if (findSupervisoryAuthority.length > 0) {
      supervisoryAuthority = findSupervisoryAuthority.map((element, index) => {
        return {
          vrRegistracije: "4",
          nazTijela: element?.nazTijela || "",
          sifDrzave: String(element?.sifDrzave || ""),
          nazNaselja: element?.nazNaselja || "",
          brPoste: element?.brPoste || "",
          ulicaKbr: element?.ulicaKbr || "",
          id: index + 1,
        };
      });
    } else {
      supervisoryAuthority = this.state.newFormData.supervisoryAuthority;
    }

    const contactInformation = data[4].map((element, index) => {
      return {
        ime: element?.ime || "",
        prezime: element?.prezime || "",
        telefon: element?.telefon || "",
        web: element?.web || "",
        email: element?.email || "",
        emailValidated: true,
        id: index + 1,
      };
    });

    let basicReviserData;

    if (data[5].length > 0) {
      basicReviserData = data[5].map((element, index) => {
        return {
          oib: element?.oibIdBrojOsobe || "",
          prezime: element?.prezimeOsobe || "",
          ime: element?.imeOsobe || "",
          idOsobe: element?.idOsobe || "",
          id: index + 1,
          requiredFieldsRevData: ["oib", "prezime", "ime", "regBroj"],
          oibValidated: true,
          regBroj: element?.regBrojOsobe || "",
        };
      });
    } else {
      basicReviserData = this.state.newFormData.basicReviserData;
    }

    let reviserRegistration;

    const reviserRegistrationResponseArr = data[6];

    if (
      reviserRegistrationResponseArr &&
      reviserRegistrationResponseArr.length > 0
    ) {
      reviserRegistration = reviserRegistrationResponseArr.map(
        (element, index) => {
          return {
            oib: element?.oibIdBrojOsobe || "",
            ime: element?.imeOsobe || "",
            prezime: element?.prezimeOsobe || "",
            idOsobe: element?.idOsobe || "",
            id: index + 1,
            requiredFieldsReviserRegistration: [
              "oib",
              "prezime",
              "ime",
              "regBroj",
            ],
            oibValidated: true,
            regBroj: element?.regBrojOsobe || "",
          };
        }
      );
    } else {
      reviserRegistration = this.state.newFormData.reviserRegistration;
    }

    //članovi

    const auditCompanyMember = data[7]
      .filter((element) => element.vrClana === 1)
      .map((element, index) => {
        return {
          vrClana: "1",
          oib: element.oib || "",
          ime: element.ime || "",
          prezime: element.prezime || "",
          naziv: element.naziv || "",
          sifDrzave: String(element.sifDrzave),
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          ulicaKbr: element.ulicaKbr,
          id: index + 1,
          oibValidated: true,
          requiredFieldsAuditCompanyMember: [
            // "ime",
            // "prezime",
            "sifDrzave",
            "ulicaKbr",
            // "naziv",
          ],
        };
      });

    const auditCompanyBoardMember = data[7]
      .filter((element) => element.vrClana === 2)
      .map((element, index) => {
        return {
          vrClana: "2",
          oib: element.oib || "",
          ime: element.ime,
          prezime: element.prezime,
          funkcija: element.funkcija,
          sifDrzave: String(element.sifDrzave),
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          ulicaKbr: element.ulicaKbr,
          id: index + 1,
          oibValidated: true,
          requiredFieldsAuditCompanyBoardMember: [
            "funkcija",
            "ime",
            "prezime",
            "sifDrzave",
            "ulicaKbr",
          ],
        };
      });

    let networkMemberInfo;
    const isDrustvoMreza = data[8].isDrustvoMreza;
    if (!isDrustvoMreza) {
      networkMemberInfo = {
        isDrustvoMreza: "0",
        idMreze: "",
      };
    } else {
      networkMemberInfo = {
        isDrustvoMreza: "1",
        idMreze: data[8].idMreze,
      };
    }

    let memberInfo;

    if (data[9].length > 0) {
      memberInfo = data[9].map((element, index) => {
        return {
          vrClana: String(element.vrClana),
          // memberType: "",
          id: index + 1,
          idMreze: element.idMreze,
          nazDrustva: element.nazDrustva || "",
          sifDrzave: String(element.sifDrzave || ""),
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          ulicaKbr: element.ulicaKbr || "",
          web: element.web || "",
          // requiredFieldsMemberInfo: ["vrClana"]
        };
      });
    } else {
      memberInfo = this.state.newFormData.memberInfo;
    }

    let oznDokumenta = {};

    if (oznaka) {
      oznDokumenta.oznDokumenta = oznaka;
    } else {
      oznDokumenta.oznDokumenta = data[10].oznDokumenta;
    }

    this.setState((prevState) => ({
      networkMemberInfo,
      update: true,
      requestsLoaded: true,
      newFormData: {
        ...prevState.newFormData,
        oznDokumenta,

        userData: {
          ...prevState.newFormData.userData,
          vrDrustva: "3",
          oznAkt: userInfo.oznAkt || "",
          idDrustva: userInfo.idDrustva || "",
          idBroj: userInfo.idBroj || "",
          nazDrustva: userInfo.nazDrustva || "",
          regBroj: userInfo.regBroj || "",
          sifPOblika: String(userInfo.sifPOblika) || "",
          opisPOblika: userInfo.opisPOblika || "",
          brRegOrig: userInfo.brRegOrig || "",
          datReg: regAdr.datReg || "",
          requiredFieldsUserData: [
            "idBroj",
            "datReg",
            "nazDrustva",
            "regBroj",
            "sifPOblika",
            // "brRegOrig"
          ],
          tstampUnosa: userInfo.tstampUnosa,
        },
        hqAddress,
        croAddress,
        officeAddress,
        registrationAddress,
        auditCompanyRegistration,
        auditCompanyRegistrationForeign,
        supervisoryAuthority,
        contactInformation,
        basicReviserData,
        auditCompanyMember,
        auditCompanyBoardMember,
        memberInfo,
        mjere: data[11],
        reviserRegistration,

      },
    }));
  };

  getCountryList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/drzave");
    this.setState(
      {
        countryList: data,
      },
      () => {
        this.getCountyList();
      }
    );
  };

  getCountyList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/zupanije");
    this.setState(
      {
        countyList: data,
      },
      () => {
        this.getNetworks();
      }
    );
  };

  getCityAndMuncipalityList = async (countyId) => {
    const { data } = await axiosInstance.get(
      `/sifarnici/gradOpcina/${countyId}`
    );
    this.setState({
      cityAndMuncipalityList: data,
    });
  };

  getDistrictList = async (id) => {
    const { data } = await axiosInstance.get(`/sifarnici/naselja/${id}`);
    this.setState({ districtList: data });
  };

  getNetworks = async () => {
    try {
      const { data } = await axiosInstance.get("/sifarnici/mreze");
      const networksList = data;

      this.setState(
        {
          networksList,
        },
        () => {
          this.getLegalForms();
        }
      );
    } catch (e) {
      throw e;
    }
  };

  checkIfUpdate = (url) => {
    return this.props.match.url.includes(url);
  };

  getLegalForms = async () => {
    const { data } = await axiosInstance.get("/sifarnici/pravniOblici");

    const legalForms = data;
    this.setState(
      {
        legalForms,
      },
      () => {
        if (
          this.checkIfUpdate(
            "/azuriraj/registar-revizorskih-drustava-iz-drugih-drzava-clanica"
          )
        ) {
          if (this.props.idDrustva != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }
          this.getDrustvoEdit();
        } else if (
          this.checkIfUpdate(
            "/azuriraj-po-zahtjevu/registar-revizorskih-drustava-iz-drugih-drzava-clanica"
          )
        ) {
          if (this.props.idDrustva != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }
          const oznDokumenta = this.props.oznDokumenta;
          this.getDrustvoEdit(oznDokumenta);
        } else {
          this.getDataFromUnosZahtjeva();
        }
      }
    );
  };

  getDataFromUnosZahtjeva = async () => {
    const { data } = await fetchFormsApi(
      `/request/${this.props.zahtjevAtrId}?isEdit=${false}`
    );

    const findObjectByLabelAndGroup = (label, group) => {
      const findLabel = data.groupList.map((el) =>
        el.controlList.find(
          (element) =>
            element.controlLabel == label && element.addressGroup === group
        )
      );
      return findLabel;
    };

    const findObjectByLabel = (label) => {
      const findLabel = data.groupList.map((el) =>
        el.controlList.find((element) => element.controlLabel == label)
      );
      return findLabel;
    };

    const findSifPOblika = findObjectByLabel("Pravni oblik");
    let sifPOblika;
    if (findSifPOblika[0].value != "") {
      const res = await axiosInstance.get(
        `sifarnici/pravniOblici/sifra?nazivPravnogOblika=${findSifPOblika[0].value}`
      );

      if (res.data && res.data.sifPravnogOblika) {
        sifPOblika = res.data.sifPravnogOblika;
      } else {
        sifPOblika = "";
      }
    } else {
      sifPOblika = "";
    }

    const findCountry = findObjectByLabelAndGroup("Naziv države", 1);

    const findDistrict = findObjectByLabelAndGroup("Naziv mjesta", 1);

    const findbrPoste = findObjectByLabelAndGroup("Poštanski broj", 1);

    const findUlicaKbr = findObjectByLabelAndGroup("Ulica i kućni broj", 1);

    // const findOfficeAdrCountry = findObjectByLabelAndGroup("Naziv države", 2);

    // const findOfficeAdrDistrict = findObjectByLabelAndGroup("Naziv mjesta", 2);

    // const findOfficeAdrbrPoste = findObjectByLabelAndGroup("Poštanski broj", 2);

    // const findOfficeAdrUlicaKbr = findObjectByLabelAndGroup(
    //   "Ulica i kućni broj",
    //   2
    // );

    const findRegAdrCountry = findObjectByLabelAndGroup("Naziv države", 2);

    const findRegAdrDistrict = findObjectByLabelAndGroup("Naziv mjesta", 2);

    const findRegAdrbrPoste = findObjectByLabelAndGroup("Poštanski broj", 2);

    const findRegAdrUlicaKbr = findObjectByLabelAndGroup(
      "Ulica i kućni broj",
      2
    );

    const findIme = findObjectByLabel("Ime glavne osobe za kontakt");
    const findPrezime = findObjectByLabel("Prezime glavne osobe za kontakt");
    const findTelefon = findObjectByLabel("Telefon/fax");
    const findEmail = findObjectByLabel("E-mail");
    const findWeb = findObjectByLabel("Adresa internetske stranice");
    const regexp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailValidated = regexp.test(findEmail[0].value);

    const contactInformation = [
      ...this.state.newFormData.contactInformation.map((element) => {
        return (
          element.id == 1 && {
            ...element,
            ime: findIme[0]?.value || "",
            prezime: findPrezime[0]?.value || "",
            telefon: findTelefon[0]?.value || "",
            web: findWeb[0]?.value || "",
            email: findEmail[0]?.value || "",
            emailValidated,
          }
        );
      }),
    ];

    let hqDistrict;
    // let officeAdrDistrict;
    let regDistrict;

    if (findCountry[0].value == 191 && findDistrict[0].value != "") {
      const { data } = await axiosInstance.get(
        `/sifarnici/naselja/naziv/${findDistrict[0].value}`
      );
      hqDistrict = data.nazNaselja;
    } else {
      hqDistrict = findDistrict[0].value;
    }

    // if (
    //   findOfficeAdrCountry[0].value == 191 &&
    //   findOfficeAdrDistrict[0].value != ""
    // ) {
    //   const { data } = await axiosInstance.get(
    //     `/sifarnici/naselja/naziv/${findOfficeAdrDistrict[0].value}`
    //   );
    //   officeAdrDistrict = data.nazNaselja;
    // } else {
    //   officeAdrDistrict = findOfficeAdrDistrict[0].value;
    // }

    if (
      findRegAdrCountry[0].value == 191 &&
      findRegAdrDistrict[0].value != ""
    ) {
      const { data } = await axiosInstance.get(
        `/sifarnici/naselja/naziv/${findRegAdrDistrict[0].value}`
      );
      regDistrict = data.nazNaselja;
    } else {
      regDistrict = findRegAdrDistrict[0].value;
    }

    const hqAddress = {
      ...this.state.newFormData.hqAddress,
      nazNaselja: hqDistrict,
      sifDrzave: findCountry[0]?.value || "",
      brPoste: findbrPoste[0]?.value || "",
      ulicaKbr: findUlicaKbr[0]?.value || "",
    };

    const findBrRegDrugeDrzave = findObjectByLabel(
      "Broj registracije kod nadležnog tijela druge države članice"
    );

    const findNazivTijelaDrugeDrzave = findObjectByLabel(
      "Naziv nadležnog tijela iz druge države članice"
    );

    const brRegDrDrzave = findBrRegDrugeDrzave[0]
      ? findBrRegDrugeDrzave[0].value
      : "";

    const nazTijelaDrDrzave = findNazivTijelaDrugeDrzave[0]
      ? findNazivTijelaDrugeDrzave[0].value
      : "";

    const auditCompanyRegistration = [
      {
        vrRegistracije: "2",
        nazTijela: nazTijelaDrDrzave,
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: brRegDrDrzave,
        datReg: "",
        id: 1,
      },
    ];

    // const officeAddress = [
    //   ...this.state.newFormData.officeAddress.map((element) => {
    //     return (
    //       element.id == 1 && {
    //         ...element,
    //         nazNaselja: officeAdrDistrict,
    //         sifDrzave: findOfficeAdrCountry[0].value,
    //         brPoste: findOfficeAdrbrPoste[0].value,
    //         ulicaKbr: findOfficeAdrUlicaKbr[0].value,
    //       }
    //     );
    //   }),
    // ];

    const brOdobrenjaMatDrzave = findObjectByLabel(
      "Broj odobrenja za rad izdanog od nadležnog tijela matične države članice"
    );
    const datumOdobrenjaMatDrzave = findObjectByLabel(
      "Datum odobrenja za rad izdanog od nadležnog tijela matične države članice"
    );
    const nazivTijelaMatDrzave = findObjectByLabel(
      "Naziv nadležnog tijela za izdavanje odobrenja za rad i registraciju iz matične države članice"
    );

    const brRegMatDrzave = brOdobrenjaMatDrzave[0]
      ? brOdobrenjaMatDrzave[0].value
      : "";
    const datRegMatDrzave = datumOdobrenjaMatDrzave[0]
      ? datumOdobrenjaMatDrzave[0].value
      : "";
    const nazTijelaMatDrzave = nazivTijelaMatDrzave[0]
      ? nazivTijelaMatDrzave[0].value
      : "";

    const registrationAddress = {
      ...this.state.newFormData.registrationAddress,
      nazNaselja: regDistrict,
      sifDrzave: findRegAdrCountry[0]?.value || "",
      brPoste: findRegAdrbrPoste[0]?.value || "",
      ulicaKbr: findRegAdrUlicaKbr[0]?.value || "",
      nazTijela: nazTijelaMatDrzave,
      brReg: brRegMatDrzave,
      datReg: datRegMatDrzave,
    };

    //re-mapiranje

    const findNazivTijelaTreceZemlje = findObjectByLabel(
      "Naziv nadležnog tijela iz trećih zemalja"
    );
    const findBrRegTreceZemlje = findObjectByLabel(
      "Broj registracije kod nadležnog tijela iz trećih zemalja"
    );

    const brRegTreceZemlje = findBrRegTreceZemlje[0]
      ? findBrRegTreceZemlje[0].value
      : "";

    const nazTijelaTreceZemlje = findNazivTijelaTreceZemlje[0]
      ? findNazivTijelaTreceZemlje[0].value
      : "";

    const auditCompanyRegistrationForeign = [
      {
        vrRegistracije: "3",
        nazTijela: nazTijelaTreceZemlje,
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: brRegTreceZemlje,
        datReg: "",
        id: 1,
      },
    ];

    this.setState(
      (prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          userData: {
            ...prevState.newFormData.userData,
            nazDrustva: data.nazivSubjekta || "",
            sifPOblika,
          },
          hqAddress,
          // officeAddress,
          registrationAddress,
          contactInformation,
          auditCompanyRegistrationForeign,
          auditCompanyRegistration,
        },
      }),
      () => {
        this.disableLoader();
      }
    );
  };

  disableLoader = () => {
    this.setState({
      requestsLoaded: true,
    });
  };

  getUserDataNetwork = async (e) => {
    // e.preventDefault();
    e.persist();

    const newState = { ...this.state };

    let findMemberObj = {
      ...newState.newFormData.memberInfo.find((element) => {
        return element.id == e.target.id;
      }),
    };

    let identifikacija = findMemberObj.oib;

    if (findMemberObj.memberType == 3) {
      identifikacija = findMemberObj.idDrugaDrzava;
    }

    try {
      const res = await axiosInstance.get(
        `/sifarnici/drustva?vrDrustva=${findMemberObj.memberType}&identifikacija=${identifikacija}`
      );
      const { data } = res;

      if (data.length === 0) {
        this.props.formSubmitError(true, "Nema dostupnih podataka!");
        return;
      }

      //ovo je potrebno testirati i vidjeti s bekendom koliko društava može imati isti oib (ako uopce mogu imati isti oib?)
      findMemberObj.idDrustva = data[0].idDrustva;

      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          memberInfo: [
            ...prevState.newFormData.memberInfo.map((element) => {
              return element.id == e.target.id ? findMemberObj : element;
            }),
          ],
        },
      }));
    } catch (e) {
      throw e;
    }
  };

  getReviserDataByOib = async (e) => {
    e.persist();

    const id = e.currentTarget.id;

    const stateCopy = { ...this.state.newFormData };
    const findReviserObject = stateCopy.basicReviserData.find(
      (element) => element.id == id
    );

    try {
      const { data } = await axiosInstance.get(
        `/sifarnici/osobe?oib=${findReviserObject.oib}`
      );

      if (data.length === 0) {
        this.props.formSubmitError(
          true,
          "Za OIB/identifikator koji ste unijeli nema dostupnih podataka o ovlaštenom revizoru! Unesite ispravan OIB/identifikator."
        );
        return;
      }

      let reviserObject = { ...findReviserObject };
      reviserObject.ime = data[0].ime;
      reviserObject.prezime = data[0].prezime;
      reviserObject.regBroj = data[0].regBroj;
      reviserObject.idOsobe = data[0].idOsobe;

      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          basicReviserData: [
            ...prevState.newFormData.basicReviserData.map((element) => {
              return element.id == id ? reviserObject : element;
            }),
          ],
        },
      }));
    } catch (e) {
      throw e;
    }
  };

  getReviserRegData = (id) => async (e) => {
    e.persist();

    const stateCopy = { ...this.state.newFormData };
    const findReviserObject = stateCopy.reviserRegistration.find(
      (element) => element.id == id
    );

    try {
      const { data } = await axiosInstance.get(
        `/sifarnici/osobe?oib=${findReviserObject.oib}`
      );

      if (data.length === 0) {
        this.props.formSubmitError(
          true,
          "Za OIB/identifikator koji ste unijeli nema dostupnih podataka o ovlaštenom revizoru! Unesite ispravan OIB/identifikator."
        );
        return;
      }

      let reviserObject = { ...findReviserObject };
      reviserObject.ime = data[0].ime;
      reviserObject.prezime = data[0].prezime;
      reviserObject.regBroj = data[0].regBroj;
      reviserObject.idOsobe = data[0].idOsobe;

      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          reviserRegistration: [
            ...prevState.newFormData.reviserRegistration.map((element) => {
              return element.id == id ? reviserObject : element;
            }),
          ],
        },
      }));
    } catch (e) {
      throw e;
    }
  };

  mappedUserInputHandler = (e, objectData) => {
    e.persist();
    const isEmail = e.target.name === "email";
    this.setState(handleMappedUserInput(e, objectData), () => {
      isEmail && this.validateEmail(e, objectData);
      if (
        (objectData.group === "basicReviserData" ||
          objectData.group === "reviserRegistration") &&
        (e.target.name === "oib" || e.target.name === "idDrugaDrzava")
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.group]: [
              ...prevState.newFormData[objectData.group].map((element) =>
                element.id == objectData.id
                  ? {
                    ...element,
                    prezime: "",
                    ime: "",
                    regBroj: "",
                    idOsobe: "",
                  }
                  : element
              ),
            ],
          },
        }));
      }
    });
  };

  funkcijaDropDownHandler = (e) => {
    e.persist()
    const id = e.target.id.replace(/[^0-9]/g, ""); 
    let funk;
      switch (Number(e.target.value)) {
        case 3:
          funk= "Direktor";
          break;
        case 4: 
          funk= "Predsjednik uprave";
          break;
        case 5:
          funk="Član uprave";
          break;
        case 6:
          funk="Prokurist";
          break;
        case 7:
          funk="Član upravnog odbora";
          break;
        default:
          break;
      }
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        auditCompanyBoardMember: [
          ...prevState.newFormData.auditCompanyBoardMember.map((element) => {
            return element.id == id
              ? {
                ...element,
                funkcija: funk,
              }
              : element;
          }),
        ],
      },
    }));
  }

  setCountryAutocompleteHandler = (values, objectData) => {
    this.setState(handleCountryAutocomplete(values, objectData));
  };

  autocompleteCountryHandler = (values, objectData) => {
    this.setState(countryAutocompleteHandler(values, objectData));
  };

  autocompleteCountyHandler = (values, objectData) => {
    this.setState(
      countyAutocompleteHandler(
        values,
        objectData,
        this.getCityAndMuncipalityList
      )
    );
  };

  autocompleteCityHandler = (values, objectData) => {
    this.setState(
      cityAndMuncipalityAutocomplete(values, objectData, this.getDistrictList)
    );
  };

  autocompleteDistrictHandler = (values, objectData) => {
    const stateCopy = this.state;

    this.setState(districtAutocompleteHandler(values, objectData), () => {
      if (
        stateCopy.newFormData[objectData.formGroup].hasOwnProperty("brPoste") &&
        values != null
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.formGroup]: {
              ...prevState.newFormData[objectData.formGroup],
              brPoste: String(values.brPoste),
            },
          },
        }));
      }
    });
  };

  userInputHandler = (e, objectData) => {
    e.persist();
    this.setState(handleUserInput(e, objectData));
  };

  handleDayClick = (date, dateString, objData) => {
    this.setState(handleDayPicker(dateString, objData));
  };

  //MREŽE

  createNewNetworkModal = () => {
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        createNewNetworkModal: !prevState.newFormData.createNewNetworkModal,
        createNewNetworkData: {
          nazMreze: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          requiredFieldsCreateNewNetwork: [
            "nazMreze",
            "sifDrzave",
            "nazNaselja",
            "brPoste",
            "ulicaKbr",
          ],
        },
      },
    }));
  };

  networkDropdownHandler = (e) => {
    e.persist();

    const memberInfo = (element) => {
      return element.vrClana == 1
        ? {
          ...element,
          vrClana: "",
          idMreze: "",
          idDrustva: "",
          nazDrustva: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          web: "",
          // oibValidated: false,
        }
        : element;
    };

    const isDrustvoMreza = e.target.value;
    this.setState((prevState) => ({
      networkMemberInfo: {
        ...prevState.networkMemberInfo,
        isDrustvoMreza,
        idMreze: "",
      },
      newFormData: {
        ...prevState.newFormData,
        memberInfo: [...prevState.newFormData.memberInfo.map(memberInfo)],
      },
    }));
  };

  setSelectedNetworkDropdown = async (e) => {
    const idMreze = e.target.value;
    this.setState((prevState) => ({
      networkMemberInfo: {
        ...prevState.networkMemberInfo,
        idMreze,
      },
    }));
  };

  openNetworkUpdateModal = () => {
    const { networkMemberInfo } = this.state;

    const findNetworkObjById = this.state.networksList.find(
      (element) => element.idMreze == networkMemberInfo.idMreze
    );

    this.setState((prevState) => ({
      showUpdateModal: true,
      newFormData: {
        ...prevState.newFormData,
        networkUpdateObj: {
          ...findNetworkObjById,
          requiredFieldsNetworkUpdate: [
            "nazMreze",
            "nazNaselja",
            "brPoste",
            "ulicaKbr",
          ],
        },
      },
    }));
  };

  hideUpdateModal = () => {
    this.setState((prevState) => ({
      showUpdateModal: false,
      newFormData: {
        ...prevState.newFormData,
        networkUpdateObj: {
          nazMreze: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          requiredFieldsNetworkUpdate: [
            "nazMreze",
            "nazNaselja",
            "brPoste",
            "ulicaKbr",
          ],
        },
      },
    }));
  };

  updateNetworkHandler = async () => {
    const stateCopy = { ...this.state.newFormData };

    const { requiredFieldsNetworkUpdate } = stateCopy.networkUpdateObj;

    const validateNetworkSubmit = validateRequiredFields(
      stateCopy.networkUpdateObj,
      requiredFieldsNetworkUpdate
    );

    if (!validateNetworkSubmit) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    this.setState({ loader: true }, async () => {
      try {
        let submitData = { ...stateCopy.networkUpdateObj };
        delete submitData.requiredFieldsNetworkUpdate;
        const res = await axiosInstance.patch(
          `/sifarnici/mreza/edit/${stateCopy.networkUpdateObj.idMreze}`,
          submitData
        );
        this.setState(
          (prevState) => ({
            loader: false,
            showUpdateModal: false,
          }),
          async () => {
            this.props.formSubmitSuccess(false, "Mreža je uspješno ažurirana!");
            const { data } = await axiosInstance.get("/sifarnici/mreze");
            const networksList = data;

            this.setState({
              networksList,
              networkMemberInfo: {
                isDrustvoMreza: true,
                idMreze: "",
              },
            });
          }
        );
      } catch (e) {
        throw e;
        this.props.formSubmitSuccess(
          true,
          "Nešto je pošlo po krivu s ažuriranjem mreže!"
        );
        this.setState({
          loader: false,
        });
      }
    });
  };

  pOblikDropdownHandler = (e) => {
    e.persist();
    const sifPOblika = e.target.value;
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          sifPOblika,
          opisPOblika: "",
        },
      },
    }));
  };

  vrClanaDropdownHandler = (selectedValue, id) => {
    if (selectedValue == null) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          memberInfo: [
            ...prevState.newFormData.memberInfo.map((element) =>
              element.id == id
                ? {
                  vrClana: "",
                  id: element.id,
                  idMreze: "",
                  idDrustva: "",
                  nazDrustva: "",
                  sifDrzave: "191",
                  nazNaselja: "",
                  brPoste: "",
                  ulicaKbr: "",
                  web: "",
                }
                : element
            ),
          ],
        },
      }));
      return;
    }

    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        memberInfo: [
          ...prevState.newFormData.memberInfo.map((element) =>
            element.id == id
              ? {
                vrClana: selectedValue.id,
                id: element.id,
                idMreze: "",
                idDrustva: "",
                nazDrustva: "",
                sifDrzave: "191",
                nazNaselja: "",
                brPoste: "",
                ulicaKbr: "",
                web: "",
              }
              : element
          ),
        ],
      },
    }));
  };

  //refactorani podaci o glavnom partneru
  dropdownHandler = (e) => {
    //TODO: testirati
    const id = e.target.id.replace(/[^0-9]/g, "");

    e.persist();
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        reviserRegistration: [
          ...prevState.newFormData.reviserRegistration.map((element) => {
            return element.id == id
              ? {
                vrVeze: e.target.value,
                idDrustva: "",
                oibIdBrojDrustva: "",
                id: element.id,
                oibValidated: false,
                ime: "",
                prezime: "",
                nazDrustva: "",
                dataFetched: false,
                sifDrzave: "",
                nazNaselja: "",
                brPoste: "",
                ulicaKbr: "",
                web: "",
                requiredFieldsReviserRegistration: ["vrVeze"],
              }
              : element;
          }),
        ],
      },
    }));
  };

  setSelectedNetworkToArray = async (e) => {
    e.persist();
    const idMreze = e.target.value;
    const id = e.target.id.replace(/[^0-9]/g, "");
    let findObject = {
      ...this.state.newFormData.memberInfo.find((element) => element.id == id),
    };

    findObject.idMreze = e.target.value;
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        memberInfo: [
          ...prevState.newFormData.memberInfo.map((element) => {
            return element.id == id ? findObject : element;
          }),
        ],
      },
    }));
  };

  createNewNetworkSubmitHandler = async () => {
    const stateCopy = { ...this.state.newFormData };

    const { requiredFieldsCreateNewNetwork } = stateCopy.createNewNetworkData;

    const validateNetworkSubmit = validateRequiredFields(
      stateCopy.createNewNetworkData,
      requiredFieldsCreateNewNetwork
    );

    if (!validateNetworkSubmit) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    this.setState({ loader: true }, async () => {
      try {
        let submitData = { ...stateCopy.createNewNetworkData };
        delete submitData.requiredFieldsCreateNewNetwork;
        const res = await axiosInstance.post("/sifarnici/mreza", submitData);
        this.setState(
          (prevState) => ({
            loader: false,
            newFormData: {
              ...prevState.newFormData,
              createNewNetworkModal: false,
            },
          }),
          async () => {
            this.props.formSubmitSuccess(
              false,
              "Nova mreža je uspješno kreirana!"
            );
            const { data } = await axiosInstance.get("/sifarnici/mreze");
            const networksList = data;

            this.setState({
              networksList,
            });
          }
        );
      } catch (e) {
        throw e;
        this.props.formSubmitSuccess(
          true,
          "Nešto je pošlo po krivu s kreiranjem mreže!"
        );
        this.setState({
          loader: false,
        });
      }
    });
  };

  multiplyComponent = (e, objData) => {
    e.persist();
    const lastElem = [...this.state.newFormData[objData.formGroup]];

    let addNewElement;

    switch (objData.formGroup) {
      case "contactInformation":
        addNewElement = {
          ime: "",
          prezime: "",
          telefon: "",
          web: "",
          email: "",
          emailValidated: false,
          id: lastElem[lastElem.length - 1].id + 1,
        };
        break;
      case "officeAddress":
        addNewElement = {
          vrAdr: "2",
          ulicaKbr: "",
          nazNaselja: "",
          brPoste: "",
          sifDrzave: "191",
          id: lastElem[lastElem.length - 1].id + 1,
          requiredFieldsOfficeAddress: ["ulicaKbr", "nazNaselja", "brPoste"],
        };
        break;
      case "basicReviserData":
        addNewElement = {
          oib: "",
          prezime: "",
          ime: "",
          regBroj: "",
          idOsobe: "",
          id: lastElem[lastElem.length - 1].id + 1,
          requiredFieldsRevData: ["oib", "prezime", "ime", "regBroj"],
          oibValidated: false,
        };
        break;
      case "auditCompanyMember":
        addNewElement = {
          vrClana: "1",
          oib: "",
          ime: "",
          prezime: "",
          naziv: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: lastElem[lastElem.length - 1].id + 1,
          oibValidated: false,
          requiredFieldsAuditCompanyMember: [
            // "ime",
            // "prezime",
            "sifDrzave",
            "ulicaKbr",
            // "naziv",
          ],
        };
        break;
      case "auditCompanyRegistration":
        addNewElement = {
          vrRegistracije: "2",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
          id: lastElem[lastElem.length - 1].id + 1,
        };
        break;
      case "auditCompanyRegistrationForeign":
        addNewElement = {
          vrRegistracije: "3",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
          id: lastElem[lastElem.length - 1].id + 1,
        };
        break;
      case "auditCompanyBoardMember":
        addNewElement = {
          vrClana: "2",
          oib: "",
          ime: "",
          prezime: "",
          funkcija: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: lastElem[lastElem.length - 1].id + 1,
          oibValidated: false,
          requiredFieldsAuditCompanyBoardMember: [
            "funkcija",
            "ime",
            "prezime",
            "sifDrzave",
            "ulicaKbr",
          ],
        };
        break;
      case "supervisoryAuthority":
        addNewElement = {
          vrRegistracije: "4",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: lastElem[lastElem.length - 1].id + 1,
        };
        break;
      case "memberInfo":
        addNewElement = {
          vrClana: "",
          memberType: "",
          id: lastElem[lastElem.length - 1].id + 1,
          idDrugaDrzava: "",
          idMreze: "",
          idDrustva: "",
          nazDrustva: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          web: "",
          oib: "",
          oibValidated: false,
          // requiredFieldsMemberInfo: ["vrClana"]
        };
        break;
      default:
        break;
    }
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objData.formGroup]: [
          ...prevState.newFormData[objData.formGroup],
          addNewElement,
        ],
      },
    }));
  };

  removeComponentHandler = (e, objectData) => {
    e.persist();
    const { formGroup } = objectData;
    const arrayLength = this.state.newFormData[formGroup].length;
    const id = e.currentTarget.id.replace(/[^0-9]/g, "");

    if (arrayLength > 1) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          [formGroup]: [
            ...prevState.newFormData[formGroup].filter(
              (element) => element.id != id
            ),
          ],
        },
      }));
    } else {
      alert("Uklanjanje nije moguće!");
    }
  };

  validateEmail = (e, objectData) => {
    const value = e.target.value;
    const regexp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailValidated = regexp.test(value);
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objectData.group]: [
          ...prevState.newFormData[objectData.group].map((element) =>
            element.id === objectData.id
              ? {
                ...element,
                emailValidated,
              }
              : element
          ),
        ],
      },
    }));
  };

  submitHandler = async (e) => {
    e.preventDefault();

    const { zahtjevAtrId } = this.props;

    const stateCopy = { ...this.state.newFormData };

    const { requiredFieldsUserData } = stateCopy.userData;
    const validateUserData = validateRequiredFields(
      stateCopy.userData,
      requiredFieldsUserData
    );

    const { requiredFieldsRegistrationAddress } = stateCopy.registrationAddress;
    const validateAddress = validateRequiredFields(
      stateCopy.registrationAddress,
      requiredFieldsRegistrationAddress
    );

    const { requiredFieldsHqAddress } = stateCopy.hqAddress;
    const validateHq = validateRequiredFields(
      stateCopy.hqAddress,
      requiredFieldsHqAddress
    );

    const { requiredFieldsCroAddress } = stateCopy.croAddress;
    const validateCroAddress = validateRequiredFields(
      stateCopy.croAddress,
      requiredFieldsCroAddress
    );

    const validateOfficeAddress = validateArrayFields(
      stateCopy.officeAddress,
      "requiredFieldsOfficeAddress"
    ).every((element) => element === true);

    const validateBasicReviserData = validateArrayFields(
      stateCopy.basicReviserData,
      "requiredFieldsRevData"
    ).every((element) => element === true);

    const validateAuditCompanyMember = validateArrayFields(
      stateCopy.auditCompanyMember,
      "requiredFieldsAuditCompanyMember"
    ).every((element) => element === true);

    const validateAuditCompanyBoardMember = validateArrayFields(
      stateCopy.auditCompanyBoardMember,
      "requiredFieldsAuditCompanyBoardMember"
    ).every((element) => element === true);

    // const validateMemberInfo = validateArrayFields(
    //   stateCopy.memberInfo,
    //   "requiredFieldsMemberInfo"
    // ).every(element => element === true);

    const validateReviserRegistration = validateArrayFields(
      stateCopy.reviserRegistration,
      "requiredFieldsReviserRegistration"
    ).every((element) => element === true);

    // const validateAuditCompanyRegistration = validateArrayFields(
    //   stateCopy.auditCompanyRegistration,
    //   "requiredFieldsAuditCompanyRegistration"
    // ).every((element) => element === true);

    // const {
    //   requiredFieldsAuditCompanyRegistrationForeign,
    // } = stateCopy.auditCompanyRegistrationForeign;

    // const validateAuditCompanyRegistrationForeign = validateRequiredFields(
    //   stateCopy.auditCompanyRegistrationForeign,
    //   requiredFieldsAuditCompanyRegistrationForeign
    // );

    // const validateSupervisoryAuthority = validateArrayFields(
    //   stateCopy.supervisoryAuthority,
    //   "requiredFieldsSupervisoryAuthority"
    // ).every((element) => element === true);

    const validateNetwork =
      this.state.networkMemberInfo.isDrustvoMreza === false;

    if (
      !validateUserData ||
      !validateAddress ||
      !validateHq ||
      !validateCroAddress ||
      !validateOfficeAddress ||
      !validateBasicReviserData ||
      !validateAuditCompanyBoardMember ||
      !validateAuditCompanyMember ||
      //  ||
      // !validateMemberInfo
      !validateReviserRegistration ||
      // !validateAuditCompanyRegistration ||
      validateNetwork
    ) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    if (
      stateCopy.userData.sifPOblika == "999" &&
      stateCopy.userData.opisPOblika.length < 1
    ) {
      return this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Unesite opis pravnog oblika!");
        }
      );
    }

    const validateAuditCompanyMemberOib = [...stateCopy.auditCompanyMember]
      .filter((element) => element.oib.length > 0)
      .every((element) => element.oibValidated === true);

    if (!validateAuditCompanyMemberOib) {
      this.props.formSubmitError(
        true,
        "OIB koji ste unijeli nije ispravan! (Član/dioničar revizorskog društva)"
      );
      return;
    }

    const validateAuditCompanyBoardMemberOib = [
      ...stateCopy.auditCompanyBoardMember,
    ]
      .filter((element) => element.oib.length > 0)
      .every((element) => element.oibValidated === true);

    if (!validateAuditCompanyBoardMemberOib) {
      this.props.formSubmitError(
        true,
        "OIB koji ste unijeli nije ispravan! (Član uprave ili upravnog odbora revizorskog društva)"
      );
      return;
    }

    const networkNotSelected = [...stateCopy.memberInfo]
      .filter((element) => element.vrClana === "1")
      .every((element) => element.idMreze);

    if (!networkNotSelected) {
      this.props.formSubmitError(true, "Odaberite pripadnost mreži!");
      return;
    }

    const emptyNazDrustva = [...stateCopy.memberInfo]
      .filter((element) => element.vrClana == 2)
      .every((element) => element.nazDrustva.length > 0);

    if (!emptyNazDrustva) {
      return this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Unesite naziv društva!");
        }
      );
    }

    //ako je korisnik odabrao pripadnost mrezi/drustvu, provjeri jesu li svi fieldovi popunjeni (adresa ili web)
    const networkAddressNotFilled = [...stateCopy.memberInfo]
      .filter((element) => element.vrClana != "")
      .every(
        (element) =>
          (element.nazNaselja &&
            element.brPoste &&
            element.ulicaKbr &&
            element.brPoste) ||
          element.web
      );

    //ovo treba dobro testirati, upozoriti testere!
    if (!networkAddressNotFilled) {
      return this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(
            true,
            "Popunite adresu ili web adresu za provjeru podataka!"
          );
        }
      );
    }
    const isEmailValidated = [...stateCopy.contactInformation].filter(
      (element) => !element.emailValidated && element.email.length > 0
    );

    if (isEmailValidated.length > 0) {
      this.setState({ error: true }, () => {
        this.props.formSubmitError(
          true,
          "E-mail koji ste upisali nije ispravan!"
        );
      });
      return;
    }

    //SUBMIT

    const userData = { ...stateCopy.userData };

    //ADRESE
    const addressArray = [];

    const hqAddress = { ...stateCopy.hqAddress };

    const croAddress = { ...stateCopy.croAddress };

    const officeAddress = [...stateCopy.officeAddress].map((element, index) => {
      // delete element.id;
      // delete element.requiredFieldsOfficeAddress;
      // return element;
      return {
        vrAdr: "2",
        ulicaKbr: element.ulicaKbr,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        sifDrzave: element.sifDrzave,
      };
    });

    delete hqAddress.requiredFieldsHqAddress;

    delete croAddress.requiredFieldsCroAddress;

    addressArray.push(hqAddress, croAddress, ...officeAddress);

    //REGISTRACIJE

    const registrationArray = [];

    const regAdr = {
      vrRegistracije: "1",
      //provjeriti jel ovo dobra sifDrzave
      sifDrzave: croAddress.sifDrzave,
      brReg: userData.regBroj,
      datReg: userData.datReg,
    };

    delete userData.datReg;
    delete userData.requiredFieldsUserData;
    delete userData.oznAkt;

    const registrationAddress = { ...stateCopy.registrationAddress };

    delete registrationAddress.requiredFieldsRegistrationAddress;

    const auditCompanyRegistration = [
      ...stateCopy.auditCompanyRegistration,
    ].map((element, index) => {
      return {
        vrRegistracije: "2",
        nazTijela: element.nazTijela,
        sifDrzave: element.sifDrzave,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        ulicaKbr: element.ulicaKbr,
        brReg: element.brReg,
        datReg: element.datReg,
      };
      // delete element.id;
      // delete element.requiredFieldsAuditCompanyRegistration;
      // return element;
    });

    const auditCompanyRegistrationForeign = [
      ...stateCopy.auditCompanyRegistrationForeign,
    ].map((element) => {
      return {
        vrRegistracije: "3",
        nazTijela: element.nazTijela,
        sifDrzave: element.sifDrzave,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        ulicaKbr: element.ulicaKbr,
        brReg: element.brReg,
        datReg: element.datReg,
      };
    });

    const supervisoryAuthority = [...stateCopy.supervisoryAuthority].map(
      (element) => {
        return {
          vrRegistracije: "4",
          nazTijela: element.nazTijela,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
        };
        // delete element.id;
        // delete element.requiredFieldsSupervisoryAuthority;
        // return element;
      }
    );

    registrationArray.push(
      regAdr,
      registrationAddress,
      ...auditCompanyRegistration,
      ...auditCompanyRegistrationForeign,
      ...supervisoryAuthority
    );

    //KONTAKT INFO

    const contactInformation = [...stateCopy.contactInformation].map(
      (element) => {
        return {
          ime: element.ime,
          prezime: element.prezime,
          telefon: element.telefon,
          web: element.web,
          email: element.email,
        };
      }
    );

    // VEZE

    const basicReviserData = [...stateCopy.basicReviserData].map((element) => {
      return {
        vrVeze: "1",
        idOsobe: String(element.idOsobe),
      };
    });

    const reviserRegistration = [...stateCopy.reviserRegistration].map(
      (element) => {
        return {
          vrVeze: "3",
          idOsobe: String(element.idOsobe),
        };
      }
    );

    //ČLANOVI

    const membersArray = [];

    const auditCompanyMember = [...stateCopy.auditCompanyMember].map(
      (element) => {
        return {
          vrClana: "1",
          oib: element.oib,
          ime: element.ime,
          prezime: element.prezime,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
          naziv: element.naziv,
        };
      }
    );

    const auditCompanyBoardMember = [...stateCopy.auditCompanyBoardMember].map(
      (element) => {
        return {
          vrClana: "2",
          oib: element.oib,
          ime: element.ime,
          funkcija: element.funkcija,
          prezime: element.prezime,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
        };
      }
    );

    membersArray.push(...auditCompanyMember, ...auditCompanyBoardMember);

    // društvo mreža

    let mrezaInfo = { ...this.state.networkMemberInfo };

    if (mrezaInfo.isDrustvoMreza == 0 || mrezaInfo.isDrustvoMreza === false) {
      delete mrezaInfo.idMreze;
      mrezaInfo.isDrustvoMreza = false;
    } else {
      mrezaInfo.isDrustvoMreza = true;
    }

    const checkMreza = mrezaInfo.hasOwnProperty("idMreze");
    if (checkMreza && !mrezaInfo.idMreze) {
      this.props.formSubmitError(true, "Odaberite mrežu !");
      return;
    }

    // članovi mreže
    const memberInfo = [...stateCopy.memberInfo].map((element) => {
      if (element.vrClana == 1) {
        return {
          idMreze: element.idMreze,
          vrClana: element.vrClana,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
          web: element.web,
        };
      }
      return {
        idDrustva: element.idDrustva,
        vrClana: element.vrClana,
        sifDrzave: element.sifDrzave,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        ulicaKbr: element.ulicaKbr,
        web: element.web,
        nazDrustva: element.nazDrustva,
      };
    });

    //oznaka dokumenta => hardkodirano => vidjeti s bekendom sto dalje

    const { oznDokumenta } = this.state.newFormData;

    const submitData = [
      5,
      userData,
      addressArray,
      registrationArray,
      contactInformation,
      basicReviserData,
      reviserRegistration,
      membersArray,
      mrezaInfo,
      memberInfo,
      oznDokumenta,
    ];

    try {
      this.setState({
        loader: true,
      });
      if (!this.state.update) {
        submitData.push([]);
        const res = await axiosInstance
          .post(`/unos/${zahtjevAtrId}`, submitData)
          .then(() =>
            this.setState({
              loader: false,
            })
          );
        this.props.formSubmitSuccess(
          false,
          "Podaci o subjektu uspješno upisani."
        );
        this.props.history.push("/odobrenje-zahtjeva");
        return;
      }
      submitData.push(stateCopy.mjere);
      const res = await axiosInstance.patch("/edit", submitData).then(() =>
        this.setState({
          loader: false,
        })
      );
      this.props.formSubmitSuccess(false, "Podaci uspješno ažurirani.");
      this.props.history.push("/pregled-registara");
    } catch (e) {
      this.props.formSubmitError(
        true,
        e.response.data.message ||
        "Nešto je pošlo po krivu, provjerite unesene podatke!"
      );
      this.setState({
        loader: false,
      });
    }
  };

  render() {
    const otherProps = {
      parentState: this.state,
      userInputHandler: this.userInputHandler,
      mappedUserInputHandler: this.mappedUserInputHandler,
      setCountryAutocompleteHandler: this.setCountryAutocompleteHandler,
      autocompleteCountryHandler: this.autocompleteCountryHandler,
      autocompleteCountyHandler: this.autocompleteCountyHandler,
      autocompleteCityHandler: this.autocompleteCityHandler,
      autocompleteDistrictHandler: this.autocompleteDistrictHandler,
      handleDayClick: this.handleDayClick,
      networkDropdownHandler: this.networkDropdownHandler,
      setSelectedNetworkDropdown: this.setSelectedNetworkDropdown,
      createNewNetworkModal: this.createNewNetworkModal,
      createNewNetworkSubmitHandler: this.createNewNetworkSubmitHandler,
      submitHandler: this.submitHandler,
      pOblikDropdownHandler: this.pOblikDropdownHandler,
      getReviserDataByOib: this.getReviserDataByOib,
      vrClanaDropdownHandler: this.vrClanaDropdownHandler,
      setSelectedNetworkToArray: this.setSelectedNetworkToArray,
      getUserData: this.getUserData,
      getUserDataNetwork: this.getUserDataNetwork,
      multiplyComponent: this.multiplyComponent,
      removeComponentHandler: this.removeComponentHandler,
      dropdownHandler: this.dropdownHandler,
      getReviserRegData: this.getReviserRegData,
      openNetworkUpdateModal: this.openNetworkUpdateModal,
      hideUpdateModal: this.hideUpdateModal,
      updateNetworkHandler: this.updateNetworkHandler,
      funkcijaDropDownHandler: this.funkcijaDropDownHandler,
    };

    return (
      <>
        {this.state.requestsLoaded ? (
          <EntryForm5 {...otherProps} />
        ) : (
          <Spinner />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zahtjevAtrId: state.formData.zahtjevAtrId,
    idDrustva: state.update.idDrustva,
    vrDrustva: state.update.vrDrustva,
    oznDokumenta: state.update.oznDokumenta,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
    purgeUpdate: () => dispatch({ type: PURGE_UPDATE }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistarRevDrustavIzDrugeDrzave);
